import { ContentType } from 'pe-core-frontend';
import { useParams } from 'react-router-dom';
export const useContentType = () => {
    const { type } = useParams();
    let contentType;
    switch (type) {
        case 'email':
            contentType = ContentType.EMAIL;
            break;
        case 'webpage':
            contentType = ContentType.WEBPAGE;
            break;
        case 'sms':
            contentType = ContentType.SMS;
            break;
        default:
            contentType = ContentType.OTHER;
    }
    return {
        type,
        contentType,
    };
};
